import { useState, useCallback } from 'react';
import { Col, Form, Input, Row } from 'antd';
import { useChangeCVV2 } from '@/hooks';
import { AppButton, Flex } from '@/components';
import formErrors from '@/utils/formErrors';
import { useTranslation } from 'react-i18next';

const gap = 24;

export const ChangePasswordCVV2 = () => {

  const [submited, setSubmited] = useState(false);
  const { formik, loading } = useChangeCVV2();

  const [t] = useTranslation(['common']);

  const handleButtonClick = useCallback(() => {
    setSubmited(true);
    formik.submitForm();
  }, [formik]);

  const { values, errors } = formik;

  const notes = t('common:messages.card-usage-notes', { returnObjects: true });
  console.log({ notes });

  return (
    <Flex direction="column" className="w-full text-base" gap={gap}>
      <Row className="w-full" gutter={[gap, gap]}>
        <ul className="detail-list">
          {(notes as any as string[] ?? []).map((item, index) => (
            <li key={index}>{index + 1}- {item}</li>
          ))}
        </ul>
        <Col xl={6} lg={8} span={12}>
          <Form.Item {...formErrors(errors.newCvv2, submited)}>
            <label className="required-label">{t('common:labels.new-cvv2')}</label>
            <Input.Password inputMode="numeric" name="newCvv2" value={values.newCvv2} onChange={formik.handleChange} />
          </Form.Item>
        </Col>
        <Col xl={6} lg={8} span={12}>
          <Form.Item {...formErrors(errors.confirmNewCvv2, submited)}>
            <label className="required-label">{t('common:labels.confirm-new-cvv2')}</label>
            <Input.Password inputMode="numeric" name="confirmNewCvv2" value={values.confirmNewCvv2} onChange={formik.handleChange} />
          </Form.Item>
        </Col>
      </Row>
      <Row className="w-full mt-auto" gutter={[gap, gap]}>
        <Col span={4} className="!ms-auto">
          <AppButton
            appVariant="submit"
            className="w-full"
            loading={loading}
            onClick={handleButtonClick}>
            {t('common:labels.update')}
          </AppButton>
        </Col>
      </Row>
    </Flex>
  );
};

export default ChangePasswordCVV2;
